import { EstadosActivacionInstallOTEnumChoice, gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { Grid, Typography } from "@mui/material";
import { OrdenTrabajo, TipoInstalacion } from "@/shared/interfaces";
import { CustomAutocompleteArrString, CustomAutocompleteNoForm, CustomTextArea } from "@/shared/components/ui";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { UseFormReturn } from "react-hook-form";
// import FormaPago from "@/shared/components/ui/FormaPago/FormaPago";
// import { useEquiposAdicionales } from "@/store/erp";
import { EquiposAdicionalesParaVentaActivaciones } from "./EquiposAdicionalesParaVentaActivaciones";
import { useEffect } from "react";
import CustomAutocompleteOptimized from "@/shared/components/ui/CustomAutocompleteOptimized";

export type DatosAdicionalesFormComponentActivacionesProps = {
  form: UseFormReturn<any>;
  ordenTrabajo?: OrdenTrabajo;
};

const DatosAdicionalesFormComponentActivaciones: React.FC<
  DatosAdicionalesFormComponentActivacionesProps
> = ({ form, ordenTrabajo }) => {

  const typInstalation = useTypeInstalation((s) => s.typInstalation);
  const isLoadingTypeInstalation = useTypeInstalation(
    (s) => s.isLoadingTypeInstalation
  );

  // En un TRASLADO, el "Tipo de Instalación" ofrece TODAS las opciones normales
  // + una opción TRASLADO (pre-seleccionada). No afecta a instalaciones.
  const esTraslado =
    (ordenTrabajo as any)?.agendamiento_data?.tipo_orden_servicio === "TRASLADO";
  const tipoInstalacionOptions = esTraslado
    ? ([...(typInstalation || []), { nombre: "TRASLADO", codigo: "TRASLADO" }] as any)
    : typInstalation || [];

  useEffect(() => {
    if (esTraslado && form.getValues()?.tipo_instalacion !== "TRASLADO") {
      form.setValue("tipo_instalacion", "TRASLADO");
    }
  }, [esTraslado]);
  // const productos = useEquiposAdicionales(s => s.productos)
  // const setAlert = useUiStore((s) => s.setAlert);

  

  // const { getCategoriaProducto } = useCategoriaProductoStore();
  // const addSelectedItemProducto = useMaterialesUtilizadosStore(
  //   (s) => s.addSelectedItemProducto
  // );
  // const equiposAdicionales = useMaterialesUtilizadosStore(
  //   (s) => s.equiposAdicionales
  // );
  // const addSelectedItemProducto = useMaterialesUtilizadosStore(
  //   s => s.addSelectedItemProducto
  // );
  // const { columnsItemMaterialEquipoAdicional } = useTableColumnsInventario({
  //   key: MaterialesKey.equiposAdicionales,
  // });
  // const productos = useEquiposAdicionales(s => s.productos)
  // const handleAgregarProducto = useEquiposAdicionales(s => s.handleAgregarProducto)
  // const handleActualizarProducto = useEquiposAdicionales(s => s.handleActualizarProducto)
  // const getDataProducto = useEquiposAdicionales(s => s.getDataProducto)
  // const handleEliminarProducto = useEquiposAdicionales(s => s.handleEliminarProducto)
  // useEffect(() => {
  //   getCategoriaProducto({})
  // }, []);
  useEffect(()=>{
    console.log("tipo instalacion:", form.getValues()?.tipo_instalacion)
    
  },[form.getValues()?.tipo_instalacion])

  return (
    <>
    
      <CustomAutocompleteOptimized<TipoInstalacion>
        size={gridSizeMdLg12}
        label={"Tipo de Instalación"}
        name="tipo_instalacion"
        // options
        options={tipoInstalacionOptions}
        valueKey="nombre" // name is the fk
        actualValueKey="codigo"
        defaultValue={esTraslado ? "TRASLADO" : (form.getValues()?.tipo_instalacion||null)}
        isLoadingData={isLoadingTypeInstalation}
        // validation
        control={form.control}
        error={form.formState.errors.tipo_instalacion as any}
        helperText={form.formState.errors.tipo_instalacion?.message as any}
        disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
        onChangeRawValue={(raw)=>{
          if(raw.nombre !="EMPAQUETADO"){
            form.setValue("subtipo_instalacion",null)
          }
        }}
      />
      {
        form.watch("tipo_instalacion") === "EMPAQUETADO" &&
        <CustomAutocompleteNoForm
          label="Subtipo de Instalación"
          isLoadingData={false}
          defaultValue={form.getValues().subtipo_instalacion || ""}
          options={
            [
              {
                nombre:"TIPO 1 (50m a 150m)",
                codigo:"TIPO 1"
              },
              {
                nombre:"TIPO 2 (151m a 300m)",
                codigo:"TIPO 2"
              },
              {
                nombre:"TIPO 3 (301m a 450m)",
                codigo:"TIPO 3"
              }
            ]
          }
          valueKey="nombre"
          actualValueKey="codigo"
          onChangeValue={(e) => {
            form.setValue('subtipo_instalacion', e)
          }}
          disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
        />
      }
      <CustomAutocompleteArrString
        label="Puntos de Red Instalados"
        name="puntos_red_instalados"
        control={form.control}
        error={form.formState.errors?.puntos_red_instalados as any}
        helperText={form.formState.errors?.puntos_red_instalados?.message as any}
        isLoadingData={false}
        options={[
          "0","1","2","3","4","5","6","7","8","9","10"
        ]}
        defaultValue={form.getValues().puntos_red_instalados || "0"}
        size={gridSizeMdLg6}
        disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
      />
      <CustomAutocompleteArrString
        label="Puntos de Red No Instalados"
        name="puntos_red_no_instalados"
        control={form.control}
        error={form.formState.errors?.puntos_red_no_instalados as any}
        helperText={form.formState.errors?.puntos_red_no_instalados?.message as any}
        isLoadingData={false}
        options={[
          "0","1","2","3","4","5","6","7","8","9","10"
        ]}
        defaultValue={form.getValues()?.puntos_red_no_instalados || 0}
        size={gridSizeMdLg6}
        disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
      />
      {/* <CustomAutocompleteArrString
        label="Routers Adicionales Instalados"
        name="routers_adicionales_instalados"
        control={form.control}
        error={form.formState.errors?.routers_adicionales_instalados as any}
        helperText={form.formState.errors?.routers_adicionales_instalados?.message as any}
        isLoadingData={false}
        options={[
          "0","1","2","3","4","5","6","7","8","9","10"
        ]}
        defaultValue={form.getValues()?.routers_adicionales_instalados || 0}
        size={gridSizeMdLg12}
        disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
      /> */}



      <Grid {...gridSizeMdLg12} container item gap={0} spacing={0}>
        <Typography variant="subtitle1" fontWeight={"bold"}>Equipos Adicionales para la Venta</Typography>
      </Grid>
      <EquiposAdicionalesParaVentaActivaciones form={form} onlyShow={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA}/>
      {
        (form.getValues()?.equipos_adicionales_preventa?.length||0)>0?
        <Grid {...gridSizeMdLg12} container item>
          <Grid {...gridSizeMdLg12} container item>
            <Typography variant="body2" >
              Equipos adicionales solicitados por el cliente:
            </Typography>
          </Grid>
          {
            form.getValues()?.equipos_adicionales_preventa?.map((x:any,index:number)=>(
              <Grid {...gridSizeMdLg12} container item key={"itemequipoadicionalpreventa-"+index}>
                <Typography variant="body2">{x.descripcion} - <b>{x.cantidad} unidad/es</b></Typography>
              </Grid>
            ))
          }
        </Grid>:
        null
      }
      {/* {
        productos.length>0 &&
        <FormaPago form={form} onlyShow={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA} />
      } */}

      
      {/* <TabTextLabel text="SERIE" /> */}
      {/* <SampleCheckbox
        label="Habilitar equipos adicionales"
        name="actualizar_nodo_olt"
        control={form.control}
        defaultValue={!!form.getValues().actualizar_nodo_olt || false}
        size={gridSize}
        disabled={form.watch("router") ? false : true}
        onClickDisabled={() => {
          setAlert(
            true,
            "Debe completar todos los datos correspondientes a detalle de activación para habilitar los equipos adicionales.",
            AlertSeverityEnum.warning
          );
        }}
      /> */}
      {/* ------- Equipo Adicional -------- */}
      {/* {form.watch("actualizar_nodo_olt") ? (
        <>
          <TabTextLabel text="Equipo Adicional" pt="48px" />
          <EquipoAdicional form={form} editSupervisor={true} />
        </>
      ) : null} */}
      

      {/* ------- materiales - serie -------- */}

      {/* =============== EQUIPOS UTILIZADOS =============== */}

      {/* =============== MATERIALES UTILIZADOS =============== */}
      {/* <MaterialesUtilizadosInstallOTTecAsig form={form} 
      ubicacion={form?.getValues()?.flota_data?.ubicacion!} onlyShow={true} /> */}
      
      <CustomTextArea
        label="Observación Activación"
        name="observacion_activacion"
        control={form.control}
        defaultValue={form.getValues()?.observacion_activacion || ''}
        error={form.formState.errors.observacion_activacion as any}
        helperText={form.formState.errors.observacion_activacion?.message as any}
        required={false}
        disabled={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA?true:false}
      />
    </>
  );
};

export default DatosAdicionalesFormComponentActivaciones;
